function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%",
  id: "a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3D1452",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52143D",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M162.4 0h185.5c57 0 77.8 6 98.6 17.1A116.3 116.3 0 01495 65.5l.7 1.2c10.7 20.5 16.4 41.5 16.4 97.4v183.8c0 57-6 77.8-17.1 98.6a116.3 116.3 0 01-48.4 48.4l-1.2.7c-20.5 10.7-41.5 16.4-97.4 16.4H164.1c-57 0-77.8-6-98.6-17.1A116.3 116.3 0 0117 446.5l-.7-1.2C5.8 425 .1 404.3 0 349.6V164.1c0-57 6-77.8 17.1-98.6A116.3 116.3 0 0165.5 17l1.2-.7C87 5.8 107.7.1 162.4 0z",
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#C675F0",
  fillOpacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M64 256.4l72.2 86.2 207.5-174.2L256.3 95z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M448 256.4L255.7 95l-87.4 73.4 207.5 174.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.5 417.6V142.5L256 95l-56.5 47.5v275.1z"
})));

var Svg3ChartsPurpleLightBordered = function Svg3ChartsPurpleLightBordered(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3ChartsPurpleLightBordered, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3charts-purple-light-bordered.b1ab007a.svg";
export { ForwardRef as ReactComponent };